const contactUsInitialValues = {
  name: "",
  email: "",
  phone: "",
  message: "",
};

export default contactUsInitialValues;
